import { render, staticRenderFns } from "./Ximi.vue?vue&type=template&id=5f2e0a48&scoped=true"
import script from "./Ximi.vue?vue&type=script&lang=js"
export * from "./Ximi.vue?vue&type=script&lang=js"
import style0 from "./Ximi.vue?vue&type=style&index=0&id=5f2e0a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2e0a48",
  null
  
)

export default component.exports